/**
 * 组件的emit事件声明
 * 基于方案设计文档生成
 */
export const emits = [
  // 无事件
];

